<template>
  <div id="printSales">
    <div class="sale" v-for="sale of sales.filter(s => !!s)">
      <div class="info">
        <div class="left">
          <div class="name">{{$t('ID')}}</div>
          <div class="value">{{ sale.id }}</div>
          <div class="name">{{$t('created_at')}}</div>
          <div class="value">{{ sale.createdAt }}</div>
          <div class="name">{{$t('for')}}</div>
          <div class="value">{{ sale.inAdvanceFor }}</div>
        </div>
        <div class="right">
          <div class="name">{{$t('name')}}</div>
          <div class="value">{{ sale.contact.firstName }} {{ sale.contact.lastName }}</div>
          <div class="name">{{$t('email')}}</div>
          <div class="value">{{ sale.contact.email }}</div>
          <div class="name">{{$t('phoneNumber')}}</div>
          <div class="value">{{ sale.contact.phone }}</div>
        </div>
      </div>
      <hr>
      <div class="delivery">
        <div class="left">
          <div class="lineTitle">{{$t('deliver_from')}}</div>
          <div class="line">{{ sale.companyInfo.name }}</div>
          <div class="line">{{ sale.companyInfo.address }}</div>
          <div class="line">{{ sale.companyInfo.zipCode }}</div>
        </div>
        <div class="right">
          <div class="lineTitle">{{$t('deliver_to')}}</div>
          <div class="line">{{ sale.contact.firstName }} {{ sale.contact.lastName }}</div>
          <div class="line">{{ sale.deliveryData.fullAddress }} {{ sale.deliveryData.app }}</div>
          <div class="line">{{ sale.deliveryData.zip }}</div>
          <div class="line" v-if="sale.deliveryData.note">{{ sale.deliveryData.note }}</div>
        </div>
      </div>
      <hr>
      <div class="details">
        <template v-for="(detail, detailIndex) of sale.details">
          <div class="quantity" :class="['line-' + detail.line.length, {first: detailIndex === 0}]">
            {{ detail.line.length === 1 ? detail.quantity + "x" : "" }}
          </div>
          <div class="name" :class="['line-' + detail.line.length, {first: detailIndex === 0}]">
            {{ detail.line.length > 1 && detail.quantity > 1 ? detail.quantity + "x" : "" }}
            {{ detail.name }}
            <div class="grow" v-if="detail.unitPrice"></div>
            <div v-if="detail.unitPrice">
              {{ detail.line.length > 1 ? "+ " : "" }}{{$tc(detail.unitPrice, sale.currency)}}
            </div>
          </div>
        </template>
      </div>
      <hr>
      <div class="total">
        <div class="line subtotal">
          <div class="name">{{$t('subTotal')}}</div>
          <div class="grow"></div>
          <div class="value">{{$tc(sale.subTotal, sale.currency)}}</div>
        </div>
        <div class="line" v-for="tax of sale.taxes">
          <div class="name">{{ tax.name }}</div>
          <div class="grow"></div>
          <div class="value">{{$tc(tax.total, sale.currency)}}</div>
        </div>
        <div class="line total">
          <div class="name">{{$t('total')}}</div>
          <div class="grow"></div>
          <div class="value">{{$tc(sale.total, sale.currency)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {

    props: {
      sales: Array
    },

    methods: {
      print() {
        window.print();
      }
    }

  }

</script>

<style lang="scss" scoped>

  .sale {
    display: block;
    break-after: page;
    break-inside: avoid;
    position: relative;
  }

  .info, .delivery {
    display: flex;
  }
  .left {
    flex-grow: 1;
  }
  .left, .right {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 20px;
    .name {
      font-weight: bold;
    }
  }
  .delivery .left,
  .delivery .right {
    display: block;
  }

  .details {
    display: grid;
    grid-template-columns: auto 1fr;
    .quantity {
      font-weight: bold;
      padding-right: 20px;
    }
    .line-1:not(.first) {
      margin-top: 4px;
      padding-top: 4px;
      border-top: 1px dashed #e5e5e5;
    }
    .line-2 {
      margin-left: 20px;
    }
    .line-3 {
      background-color: red;
    }
    .name {
      display: flex;
      .grow {
        flex-grow: 1;
        // border-bottom: 2px dotted #ececec;
        margin: 0 2px 3px;
      }
    }
  }

  .total {
    .line {
      display: flex;
      .grow {
        flex-grow: 1;
        margin: 0 2px 3px;
      }
    }
    .name {
      font-weight: bold;
    }
    .value {
      text-align: right;
    }
    .grow {
      // border-bottom: 2px dotted #ececec;
    }
    .subtotal {
      margin-bottom: 4px;
      padding-bottom: 4px;
      border-bottom: 1px dashed #e5e5e5;
    }
    .total {
      margin-top: 4px;
      padding-top: 4px;
      border-top: 1px dashed #e5e5e5;
    }
  }

  .delivery {
    .lineTitle {
      font-weight: bold;
    }
  }

  hr {
    margin: 20px 0;
    border: none;
    border-bottom: 1px solid #cccccc;
  }

</style>

<style lang="scss">

  @media screen {
    #printSales {
      display: none;
    }
  }

  @media print {

    html, body {
      overflow: visible;
      background: transparent;
    }

    #sale .panel {
      display: none;
    }

    .no-print {
      display: none;
    }
  }

  @page {
    margin: 80px 60px;
  }

</style>